import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { MdbModalService } from 'src/lib/mdb5-adapted/public-api';
import { MdbRippleModule } from 'src/lib/mdb5-adapted/public-api';
import { NgxPaginationModule, PaginationInstance } from 'ngx-pagination';
import { Observable } from 'rxjs';
import { AppUtilityService } from 'src/app/app-utility.service';
import { AreaModel, RegionModel } from 'src/app/core/models/region.model';

import { BranchService } from '@lmsrestServices';
import { LmsTableWrapperComponent } from '@lmsShared';

import { RegionAdminDialogComponent } from './region-admin-dialog/region-admin-dialog.component';
import { RegionsAddComponent } from './regions-add/regions-add.component';

@Component({
  selector: 'app-regions-admin',
  templateUrl: './regions-admin.component.html',
  styleUrls: ['./regions-admin.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgxPaginationModule, MdbRippleModule, LmsTableWrapperComponent],
})
export class RegionsAdminComponent implements OnInit {
  config: PaginationInstance = {
    id: 'pager',
    itemsPerPage: 6,
    currentPage: 1,
  };

  regionAdminForm = this.fb.group({
    id: [0],
    regionNumber: [0],
    name: ['', [Validators.required]],
    areas: new FormArray([]),
  });
  //isEditing = false;
  enableEditIndex: number;
  editAreaIndex: number;
  lstadminAreas: AreaModel[];
  adminareaSelected: AreaModel;
  isAreaEditing = false;

  dbregions$: Observable<RegionModel[]>;
  dbregions: RegionModel[];
  adminregionSelected: RegionModel;
  submitted = false;

  constructor(
    private fb: FormBuilder,
    private branchService: BranchService,
    private global_utility: AppUtilityService,
    private modalService: MdbModalService
  ) {
    this.dbregions$ = this.branchService.getAllRegions();
  }

  ngOnInit(): void {
    this.fetchAllRegions()
      .then((regions: RegionModel[]) => {
        this.dbregions = regions;
      })
      .catch((err) => {
        this.global_utility.error(err);
      });
  }

  fetchAllRegions(): Promise<RegionModel[]> {
    return new Promise<RegionModel[]>((resolve, reject) => {
      this.dbregions$.subscribe({
        next: (regionres) => {
          if (regionres) {
            console.log(regionres);

            resolve(
              regionres.sort((a, b) => {
                if (!a.id || !b.id) return 0; // Handle missing ids
                return Number(a.id) - Number(b.id);
              })
            );

            return;
            // a.name.localeCompare(b.name, undefined, {
            //   sensitivity: 'base',
            //   numeric: true,
            // })
            //);
          }
          resolve([]);
        },
        complete: () => {
          this.global_utility.stopLoading();
        },
        error(err) {
          reject(new Error(err));
        },
      });
    });
  }

  selectRegion(region1: RegionModel) {
    this.modalService
      .open(RegionAdminDialogComponent, {
        modalClass: 'modal-md modal-dialog-centered',
        containerClass: 'd-flex',
        data: {
          region_Ar: region1,
        },
      })
      .onClose.subscribe({
        next: (new_region) => {
          if (new_region) {
            //SAve to DB
            this.branchService.saveRegion(new_region).subscribe((res) => {
              if (!res) {
                this.global_utility.error('Update region failed.', 'Add branch failed!');
              }
              this.fetchAllRegions()
                .then((result) => {
                  this.dbregions = result.sort((a, b) => {
                    if (!a.id || !b.id) return 0; // Handle missing ids
                    return Number(a.id) - Number(b.id);
                  });
                })
                .catch(() => {
                  this.global_utility.error('Update region failed.', 'Add branch failed!');
                });
            });
          }
        },
      });
  }

  addAreaRow() {
    const newArea = new AreaModel();
    newArea.id = 0;
    newArea.name = '';

    const areasForm = this.fb.group({
      id: [newArea.id, []],
      name: [newArea.name, [Validators.required]],
    });

    this.regionAdminForm.get('areas')?.enable();
    this.regionAdminForm.get('areas')?.addValidators(Validators.required);
    this.regionAdminForm.get('areas')?.updateValueAndValidity();

    this.lstadminAreas.push(newArea);
    (this.regionAdminForm.get('areas') as FormArray).push(areasForm);
  }

  get areas() {
    return (this.regionAdminForm.get('areas') as FormArray).controls;
  }

  createNewRegion() {
    const lstSize = this.dbregions.length;

    this.modalService
      .open(RegionsAddComponent, {
        modalClass: 'modal-md modal-dialog-centered',
        containerClass: 'd-flex',
        data: {
          region_Ar: null,
        },
      })
      .onClose.subscribe({
        next: (new_region) => {
          if (new_region) {
            //Save to DB
            this.branchService.createRegion(new_region).subscribe((res) => {
              if (!res) {
                this.global_utility.error('Add new branch failed.', 'Add branch failed!');
              }
              this.dbregions = res.sort((a, b) => {
                if (!a.id || !b.id) return 0; // Handle missing ids
                return Number(a.id) - Number(b.id);
              });
            });
          } else {
            console.log('why');
          }
        },
      });
  }


  deleteRegion(region: any) {
    this.global_utility.startLoading('Deleting region...');
    this.branchService.deleteRegion(region).subscribe((res) => {
      this.dbregions = res;
      this.global_utility.stopLoading();
    });
  }

  cancel() {
    (this.regionAdminForm.get('areas') as FormArray).clear();

    // clears the region selected
    this.isAreaEditing = false;
    (this.regionAdminForm.get('areas') as FormArray).reset();
    this.regionAdminForm.reset();
  }

}
